
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.057 7.516a3.335 3.335 0 01-6.557-.85 3.333 3.333 0 016.557-.85h6.776a.85.85 0 110 1.7H9.057zm-5.74 5.817c0-.47.38-.85.85-.85h6.776a3.335 3.335 0 016.557.85 3.333 3.333 0 01-6.557.85H4.167a.85.85 0 01-.85-.85z"}})])
          )
        }
      }
    